import hybrid from "@general/utils/appHybrid";
import {currentUserToken, onLogin} from './index'

const $ = window.$

const presentLoginWall = () => {
  const inApp = $('html').hasClass('app-only')
  const $wall = $(`
    <div data-auth-hide class="u-center" style="text-align: center">
      <h2 class="o-section__heading">Voor je kan deelnemen vragen we je om in te loggen.</h2>
      <a href="#" class="c-button">Log in om verder te gaan</a>
    </div>
  `)

  $('#webform .container').hide()
  $('#webform').append($wall)

  $wall.click('a', function (e) {
    e.preventDefault();
    if (inApp) {
      hybrid.call('showAuthentication', { tier: 'light' })
    } else {
      document.location = '/login';
    }
  })
}

const clearLoginWall = () => {
  document.querySelectorAll('[data-auth-hide]').forEach(el => el.classList.add('hidden'))
  $('#webform .container').show()
  document.querySelectorAll('[data-role=webform-auth-token]').forEach((el) => {
    el.value = currentUserToken
  })
}

export default {
  init() {
    onLogin(clearLoginWall)

    $(document).on('page:load', function () {
      if (
        $('[data-webform-id][data-login-required=true]').length > 0 && // This page has a webform that requires login
        !currentUserToken                                              // The user is not logged in
      ) {
        presentLoginWall()
      }
    })
  }
}
